import { RecentlyViewed } from '@theme/recently-viewed-products';
import { morphSection } from '@theme/section-renderer';

class RecentlyViewedSection extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded === 'true') return;

    this.#loadProducts();
  }

  async #loadProducts() {
    const { sectionId, currentProductId, maxProducts = '4' } = this.dataset;
    if (!sectionId) return;

    const productIds = RecentlyViewed.getProducts()
      .filter((id) => id !== currentProductId)
      .slice(0, Number(maxProducts));

    if (productIds.length === 0) return;

    const url = new URL(Theme.routes.search_url, window.location.origin);
    url.searchParams.set('q', productIds.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');

    try {
      const response = await fetch(`${url}&section_id=${sectionId}`);
      if (!response.ok) throw new Error(`Server returned ${response.status}`);

      const markup = await response.text();
      if (!markup.trim()) return;

      await morphSection(sectionId, markup, { injectStylesheet: true });
    } catch (error) {
      console.error('Recently viewed products error:', error);
    }
  }
}

if (!customElements.get('recently-viewed-section')) {
  customElements.define('recently-viewed-section', RecentlyViewedSection);
}
